import { createContext } from 'react';

import { NOOP } from '../../constants/emptys';
import { AnalyticsApi } from './types';

export const AnalyticsContext = createContext<AnalyticsApi>({
  trackEvent: NOOP,
});
